//#region IMPORT
import React, { useState } from 'react';
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  Box as MuiBox,
  Box,
  Stack,
  Card,
  Typography,
  IconButton,
  Tooltip,
  tooltipClasses,
  styled,
  LinearProgress,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  DriveFolderUpload as FileUploadIcon,
  Refresh as RefreshIcon,
  Copyright as CopyrightIcon,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AuthButton } from '../../../../Components/MUIs';
/** AG-grid Import */
import Split from 'react-split';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { Button } from '../../../../Components/MUIs';
// 필터관련 컴포넌트
import { GridFilterButton } from '../../../../Components/GridFilterButton';
import { GridFilterSummary } from '../../../../Components/GridFilterSummary';

const leftSize = 50;
const rightSize = 50;
function ADM_BASIC(props) {
  // 커스터마이징된 Tooltip 생성
  const LargeTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#4CAF50', // 본체 배경 초록
      color: '#fff',
      fontSize: '0.9rem',
      padding: theme.spacing(1),
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#4CAF50', // 꼬리도 동일 색으로!
    },
  }));

  // 필터관련
  const [gridApi, setGridApi] = React.useState(null);
  const [gridColumnApi, setGridColumnApi] = React.useState(null);
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [headerMap, setHeaderMap] = React.useState({});
  const [isFiltered, setIsFiltered] = React.useState(false);
  const selectedFiltersRef = React.useRef(selectedFilters);

  React.useEffect(() => {
    selectedFiltersRef.current = selectedFilters;
    if (props.gridRef1?.current?.api) {
      props.gridRef1.current.api.onFilterChanged(); // 필터 적용
    }
  }, [selectedFilters]);

  //#region 웹(컬럼 세팅)
  const columnDefs = [
    {
      field: 'CUST_CD',
      headerName: '사업장코드',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'left',
      },
      // flex: 1,
    },
    {
      field: 'GROUP_NO',
      headerName: '그룹',
      minWidth: 80,
      maxWidth: 80,
      editable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'FILE_NAME',
      headerName: '파일명',
      tooltipField: 'FILE_NAME',
      minWidth: 280,
      editable: false,
      cellStyle: { textAlign: 'left' },
      //flex: 1,
      // cellRenderer: (e) => {
      //   if (!e.data) return null;

      //   const tooltipProps = {
      //     title: e.value,
      //     arrow: true,
      //     enterDelay: 0,
      //     disableInteractive: false,
      //     componentsProps: {
      //       tooltip: {
      //         sx: {
      //           fontSize: '0.95rem',
      //           padding: '10px 16px',
      //           maxWidth: 'none',
      //           backgroundColor: '#333',
      //         },
      //       },
      //     },
      //   };

      //   return (
      //     <Tooltip {...tooltipProps}>
      //       <span style={{ cursor: 'pointer' }}>{e.data.FILE_NAME}</span>
      //     </Tooltip>
      //   );
      // }
    },
    {
      field: 'UPLOAD_DATE',
      headerName: '업로드 일자',
      minWidth: 130,
      maxWidth: 130,
      editable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'STATUS',
      headerName: '상태',
      minWidth: 100,
      maxWidth: 100,
      editable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'FAIL_REASON',
      headerName: '실패사유',
      tooltipField: 'FAIL_REASON',
      width: 260,
      minWidth: 130,
      editable: false,
      cellStyle: { textAlign: 'left' },
    },
  ];
  //#endregion

  //#region 함수
  const gridOptions = {
    singleClickEdit: true,
    rowClassRules: {
      'new-row': (params) => params.data && params.data.newYn === 'Y', // params.data가 존재하는지 확인 후 처리
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
    isExternalFilterPresent: () => true, // 외부 필터 사용
    doesExternalFilterPass(node) {
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      // 선택된 필터 값으로 통과 여부 판단
      const filters = selectedFiltersRef.current || {};
      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        return values.includes(node.data[field]);
      });
    },
  };

  // 파일 하나 제거 함수
  const handleRemoveFile = (indexToRemove) => {
    const newFiles = props.files.filter((_, i) => i !== indexToRemove);
    props.setFiles(newFiles);
  };

  const containerStyle = {
    // backgroundColor: '#eaf6ff',
    // padding: '40px',
    // borderRadius: '20px',
    // // maxWidth: '1000px',
    // width: '100%',
    // heigh: '100%',
    // margin: '0 auto',
    backgroundColor: '#eaf6ff',
    padding: '20px',
    borderRadius: '20px',
    width: '100%',
    overflowX: 'hidden', // ✅ 추가!
    boxSizing: 'border-box', // ✅ 추가
  };

  const dropAreaStyle = {
    border: '2px dashed #bbb',
    borderRadius: '12px',
    padding: '30px',
    textAlign: 'center',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease',
  };

  const listContainerStyle = {
    marginTop: '20px',
    padding: '10px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    display: 'flex',
    overflowX: 'auto',
    gap: '20px',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  };

  const fileItemStyle = {
    minWidth: '160px',
    maxWidth: '160px',
    padding: '10px',
    border: '1px solid #eee',
    borderRadius: '10px',
    backgroundColor: '#fdfdfd',
    textAlign: 'center',
    flexShrink: 0,
  };

  const fileIconStyle = {
    fontSize: '40px',
    marginBottom: '6px',
  };
  const imageStyle = {
    width: '80px',
    height: '80px',
    marginBottom: '20px',
    opacity: props.isDragging ? 1 : 0.6,
    transition: 'opacity 0.3s ease',
  };

  const browseStyle = {
    color: '#2196f3',
    cursor: 'pointer',
    textDecoration: 'underline',
  };
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="AiDocumentManager"
          searchYn="N"
          addYn="N"
          saveYn="N"
          searchBox="N"
          printYn="N"
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            props.searchRef.current.searchText = e;
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchRef.current.coList,
                    value: props.searchRef.current.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);
                      await props.SearchLogic1();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchRef.current.custList,
              value: props.searchRef.current.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);
                await props.SearchLogic1();
              },
            },
          ]}
          grids={
            <Box
              sx={{
                // height: 'calc(100vh - 130px)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                pb: 2,
              }}
            >
              {/* 숨겨진 input (파일 선택) */}
              <input
                type="file"
                ref={props.fileInputRef}
                onChange={props.handleDrop2}
                style={{ display: 'none' }}
                // accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.hwp,.png,.jpg,.jpeg"
                // accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg"
                accept=".xls,.xlsx"
                multiple
              />

              <Box sx={{ height: '100%', pt: 1 }}>
                <Split
                  sizes={[leftSize, rightSize]} // 초기 비율
                  minSize={150} // 최소 크기
                  expandToMin={false} // 최소 크기보다 작아지지 않도록 설정
                  gutterSize={10} // 드래그 바 크기
                  gutterAlign="center"
                  cursor="col-resize"
                  className="split-container"
                >
                  {/* 왼쪽 영역 */}
                  <Stack direction={'column'} width={'100%'} height={'100%'}>
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderColor: 'divider',
                        borderRadius: '10px',
                        p: 2,
                        pt: 1,
                        backgroundColor: '#FFF',
                      }}
                    >
                      <div style={containerStyle}>
                        <div
                          style={dropAreaStyle}
                          onDrop={props.handleDrop1}
                          onDragOver={props.handleDragOver}
                          onDragEnter={props.handleDragEnter}
                          onDragLeave={props.handleDragLeave}
                        >
                          {/* <img
                    src="https://cdn-icons-png.flaticon.com/512/337/337940.png"
                    alt="icon"
                    style={{ width: '60px', marginBottom: '10px' }}
                  /> */}
                          <img
                            src={
                              props.isDragging
                                ? 'https://cdn-icons-png.flaticon.com/512/1375/1375106.png' // 강조 이미지 (같은 거 사용해도 OK)
                                : 'https://cdn-icons-png.flaticon.com/512/1375/1375106.png'
                            }
                            alt="upload"
                            style={imageStyle}
                          />

                          {/* 텍스트 부분 조건 분기 */}
                          {props.isDragging ? (
                            <p
                              style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#2196f3',
                              }}
                            >
                              여기에 놓으세요!
                            </p>
                          ) : (
                            <React.Fragment>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: '500',
                                    fontSize: '16px',
                                  }}
                                >
                                  자동화를 실행할 파일을 이곳에 드래그하거나
                                  업로드해 주세요. 또는
                                </p>
                                <span>
                                  <Button
                                    variant="text"
                                    name="선택"
                                    onClick={() =>
                                      props.fileInputRef.current.click()
                                    }
                                  />
                                </span>
                              </Box>
                            </React.Fragment>
                          )}
                        </div>

                        {props.files.length > 0 && (
                          <React.Fragment>
                            {/* 업로드된 파일 목록 */}
                            <Box sx={{ position: 'relative', mt: 1 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  mb: 1,
                                }}
                              >
                                <Typography
                                  sx={{ fontWeight: 'bold', fontSize: '18px' }}
                                >
                                  업로드된 파일 목록:
                                </Typography>
                                <Typography
                                  sx={{ fontSize: '16px', color: '#888' }}
                                >
                                  ({props.files.length})
                                </Typography>
                              </Box>

                              {/* 실행 버튼 - 우측 상단 */}
                              <Box
                                sx={{ position: 'absolute', top: 0, right: 0 }}
                              >
                                <Button
                                  name="실행"
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    if (!props.validateSelection()) return;

                                    props.SendOutLookMail();
                                  }}
                                  sx={{ borderRadius: 2 }}
                                ></Button>
                              </Box>

                              <Box
                                sx={{
                                  mt: 2,
                                  p: 1,
                                  borderRadius: '12px',
                                  backgroundColor: '#fff',
                                  display: 'flex',
                                  overflowX: 'auto',
                                  gap: 2,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {props.files.map((file, index) => (
                                  <Box
                                    key={index}
                                    sx={{
                                      minWidth: 160,
                                      maxWidth: 160,
                                      p: 1,
                                      border: '1px solid #eee',
                                      borderRadius: '10px',
                                      backgroundColor: '#fdfdfd',
                                      textAlign: 'center',
                                      position: 'relative',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: 40 }}>
                                      📄
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: 13,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {file.name}
                                    </Typography>
                                    <Typography
                                      sx={{ fontSize: 12, color: '#888' }}
                                    >
                                      {Math.round(file.size / 1024)} KB
                                    </Typography>

                                    {/* 삭제 버튼 */}
                                    <Button
                                      sx={{
                                        position: 'absolute',
                                        top: '6px',
                                        right: '6px',
                                        border: 'none',
                                        background: 'transparent',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        padding: '2px 6px',
                                        minWidth: 0,
                                        cursor: 'pointer',
                                        lineHeight: '1',
                                        color: '#e57373',
                                      }}
                                      name="X"
                                      onClick={() => handleRemoveFile(index)}
                                    />
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          </React.Fragment>
                        )}

                        <React.Fragment>
                          <Box sx={{ mt: 2 }}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 2,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 'bold',
                                  fontSize: '20px',
                                  mr: 1,
                                }}
                              >
                                📊 처리 결과
                              </Typography>

                              <Tooltip
                                title={
                                  '현재 가장 최근 작업(그룹1)의 처리 결과만 표시됩니다.'
                                }
                                arrow
                                enterDelay={300}
                                placement="right"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: '0.9rem',
                                      padding: '8px 12px',
                                      maxWidth: 500,
                                      backgroundColor: '#333',
                                      whiteSpace: 'pre-wrap',
                                    },
                                  },
                                }}
                              >
                                <button
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '1rem',
                                    borderRadius: '100%',
                                    color: '#f44336',
                                    border: '1px #e0e0e0 solid',
                                    backgroundColor: '#fff',
                                    width: '1.4rem',
                                    height: '1.4rem',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <InfoOutlinedIcon
                                    fontSize="small"
                                    sx={{ color: '#888', flexShrink: 0 }}
                                  />
                                </button>
                              </Tooltip>
                            </Box>

                            {/* 통계 카드 라인 */}
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'stretch',
                                flexWrap: 'nowrap',
                                gap: 2,
                                overflowX: 'auto',
                              }}
                            >
                              {[
                                {
                                  label: '총 건수',
                                  icon: '📦',
                                  value: props.resultSummary.total,
                                  bgColor: '#fff8e1',
                                  borderColor: '#ffb300',
                                },
                                {
                                  label: '성공',
                                  icon: '✅',
                                  value: props.resultSummary.success,
                                  bgColor: '#e8f5e9',
                                  borderColor: '#4caf50',
                                },
                                {
                                  label: '실패',
                                  icon: '❌',
                                  value: props.resultSummary.fail,
                                  bgColor: '#ffebee',
                                  borderColor: '#f44336',
                                },
                                {
                                  label: '처리 시간',
                                  icon: '⏱️',
                                  value: props.resultSummary.time,
                                  bgColor: '#e3f2fd',
                                  borderColor: '#2196f3',
                                },
                              ].map((item, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    flex: '1 1 0',
                                    minWidth: 0,
                                    p: 1.5,
                                    borderRadius: 2,
                                    backgroundColor: item.bgColor,
                                    border: `1px solid ${item.borderColor}`,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    gap: 1,
                                  }}
                                >
                                  <Typography fontSize="1.3rem">
                                    {item.icon}
                                  </Typography>
                                  <Box>
                                    <Typography
                                      fontSize="0.9rem"
                                      sx={{
                                        color: '#666',
                                        mb: 0.3,
                                        lineHeight: 1.1,
                                      }}
                                    >
                                      {item.label}
                                    </Typography>
                                    <Typography
                                      fontWeight="bold"
                                      fontSize="1.1rem"
                                      color="text.primary"
                                      sx={{ lineHeight: 1.1 }}
                                    >
                                      {item.value}
                                    </Typography>
                                  </Box>
                                </Box>
                              ))}
                            </Box>

                            {/* 성공률/실패률 */}
                            {/* <Box sx={{ display: 'flex', gap: 3, mt: 3, flexWrap: 'wrap' }}>
                              <Box sx={{ flex: 1, minWidth: '200px' }}>
                                <Typography variant="subtitle2" color="success.main" gutterBottom>
                                  ✅ 성공률: {props.resultSummary.successRate}%
                                </Typography>
                                <LinearProgress
                                  variant="determinate"
                                  value={props.resultSummary.successRate}
                                  sx={{ height: 10, borderRadius: 5, backgroundColor: '#e0f2f1' }}
                                  color="success"
                                />
                              </Box>
                              <Box sx={{ flex: 1, minWidth: '200px' }}>
                                <Typography variant="subtitle2" color="error" gutterBottom>
                                  ❌ 실패률: {props.resultSummary.failRate}%
                                </Typography>
                                <LinearProgress
                                  variant="determinate"
                                  value={props.resultSummary.failRate}
                                  sx={{ height: 10, borderRadius: 5, backgroundColor: '#ffebee' }}
                                  color="error"
                                />
                              </Box>
                            </Box> */}
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 1.5,
                                mt: 3,
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                maxWidth: '100%',
                              }}
                            >
                              {[
                                {
                                  label: '진행률',
                                  value: props.resultSummary.progressRate,
                                  color: 'info.main',
                                  bgColor: '#bbdefb',
                                  icon: '⏳',
                                },
                                {
                                  label: '성공률',
                                  value: props.resultSummary.successRate,
                                  color: 'success.main',
                                  bgColor: '#e0f2f1',
                                  icon: '✅',
                                },
                                {
                                  label: '실패률',
                                  value: props.resultSummary.failRate,
                                  color: 'error.main',
                                  bgColor: '#ffebee',
                                  icon: '❌',
                                },
                              ].map(
                                (
                                  { label, value, color, bgColor, icon },
                                  idx
                                ) => (
                                  <Box
                                    key={idx}
                                    sx={{
                                      flex: '1 1 180px', // 최소 180px, 가로공간 남으면 늘어남
                                      maxWidth: 'calc(33% - 10px)', // 최대 33%씩 차지, gap 고려
                                      backgroundColor: bgColor,
                                      borderRadius: 3,
                                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                      p: 1.2,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 0.8,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.7,
                                      }}
                                    >
                                      <Typography fontSize="1.2rem">
                                        {icon}
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: '600', color: color }}
                                      >
                                        {label}: {(value ?? 0).toFixed(1)}%
                                      </Typography>
                                    </Box>

                                    <LinearProgress
                                      variant="determinate"
                                      value={value}
                                      sx={{
                                        height: 7,
                                        borderRadius: 4,
                                        backgroundColor: bgColor,
                                        '& .MuiLinearProgress-bar': {
                                          borderRadius: 4,
                                          backgroundColor: color,
                                        },
                                      }}
                                    />
                                  </Box>
                                )
                              )}
                            </Box>
                          </Box>
                        </React.Fragment>
                      </div>
                    </Box>
                  </Stack>

                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderColor: 'divider',
                      borderRadius: '10px',
                      p: 2,
                      pt: 1,
                      backgroundColor: '#FFF',
                    }}
                  >
                    <Card
                      sx={{
                        flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        boxShadow: 'none',
                        overflow: 'visible',
                      }}
                    >
                      {/* 제목 + 필터 한 그룹 */}
                      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                          sx={{
                            fontSize: '1.05rem',
                            fontWeight: 'bold',
                            color: '#2CA900',
                            pb: 2,
                            pt: 2,
                          }}
                        >
                          최근 업로드
                        </Typography>

                        {props.gridRef1 && (
                          <GridFilterButton
                            gridRef={props.gridRef1}
                            gridApi={gridApi}
                            gridColumnApi={gridColumnApi}
                            rowData={props.rowData1}
                            selectedFiltersRef={selectedFiltersRef}
                            selectedFilters={selectedFilters}
                            setSelectedFilters={setSelectedFilters}
                            setIsFiltered={setIsFiltered}
                            setHeaderMap={setHeaderMap}
                            headerMap={headerMap}
                          />
                        )}
                      </MuiBox>

                      {/* 타이머 & 수동 재조회 버튼 */}
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <Typography color="text.secondary">
                          다음 자동 재조회까지: {props.countdown}초
                        </Typography>
                        <LargeTooltip title="재조회" arrow placement="top">
                          <IconButton
                            color="secondary"
                            sx={{
                              m: 1,
                              border: 1,
                            }}
                            variant="outlined"
                            onClick={() => {
                              if (!props.validateSelection()) return;

                              props.handleManualRefresh();
                            }}
                          >
                            <RefreshIcon style={{ margin: 0 }} />
                          </IconButton>
                        </LargeTooltip>
                      </Box>
                    </Card>
                    <div
                      className="ag-theme-alpine no-scroll"
                      style={{ height: '100%', width: '100%' }}
                    >
                      {/* 필터 요약 바 */}
                      {props.gridRef1 && (
                        <GridFilterSummary
                          isFiltered={isFiltered}
                          selectedFilters={selectedFilters}
                          headerMap={headerMap}
                          setSelectedFilters={setSelectedFilters}
                        />
                      )}
                      <AgGridReact
                        getRowId={(params) => {
                          return params.data.no;
                        }}
                        ref={props.gridRef1}
                        onGridReady={(params) => {
                          setGridApi(params.api);
                          setGridColumnApi(params.columnApi);
                        }}
                        animationRows={true}
                        columnDefs={columnDefs}
                        rowData={props.rowData1}
                        defaultColDef={{
                          minWidth: 100,
                          editable: false,
                          resizable: true,
                          sortable: true,
                          filter: true,
                          // floatingFilter: true,
                        }}
                        gridOptions={gridOptions}
                        suppressCellFocus={true}
                        stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
                        rowSelection="multiple"
                        // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        onSelectionChanged={() => {
                          GridFunctions.onSelectionChanged(
                            props.gridRef1,
                            (_selected) => {
                              props.setSelectedRowData1(_selected);
                            }
                          );
                        }}
                        // onSelectionChanged={() => {
                        //   const api = gridRef.current?.api;
                        //   if (!api) return;
                        //   const selectedNodes = api.getSelectedNodes();
                        //   const selectedData = selectedNodes.map((node) => node.data);

                        //   if (onSelectionChanged) {
                        //     onSelectionChanged(gridRef);
                        //   } else {
                        //     dispatch(setSelected({ gridId, selected: selectedData }));
                        //   }
                        // }}
                        onCellValueChanged={(e) => {
                          GridFunctions.onCellValueChanged(
                            e,
                            props.gridRef1,
                            props.setChangedRowData1
                          );
                        }}
                        // onCellValueChanged={(e) => {
                        //   if (onCellValueChanged) {
                        //     onCellValueChanged(e, gridRef);
                        //   } else {
                        //     GridFunctions.onCellValueChanged(e, gridRef, (newChanged) => {
                        //       dispatch(setChanged({ gridId, changed: newChanged }));
                        //     });
                        //   }
                        // }}
                        pagination={true} // enable pagination
                        paginationPageSize={100} // sets 10 rows per page (default is 100)
                        paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
                        localeText={{
                          // 기본 텍스트
                          page: '페이지',
                          more: '더보기',
                          to: '~',
                          of: '/',
                          next: '다음',
                          last: '마지막',
                          first: '처음',
                          previous: '이전',
                          loadingOoo: '불러오는 중...',

                          // 필터 & 패널 등
                          selectAll: '전체 선택',
                          searchOoo: '검색...',
                          blanks: '공백',

                          // 페이지 사이즈 선택기
                          pageSizeSelectorLabel: '페이지 당 행 수',

                          // 기본 페이지네이션 설명
                          paginationPageSize: '페이지 당 행 수',
                          paginationNumberFormatter: (params) =>
                            `${params.value}`,
                        }}
                        onCellMouseOver={props.handleCellMouseOver}
                        onCellMouseOut={props.handleCellMouseOut}
                      />
                      {props.tooltipInfo.show && (
                        <Box
                          sx={{
                            position: 'fixed',
                            top: props.tooltipInfo.y + 10,
                            left: props.tooltipInfo.x + 10,
                            backgroundColor: '#333',
                            color: '#fff',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            zIndex: 9999,
                            pointerEvents: 'none',
                          }}
                        >
                          {props.tooltipInfo.content}
                        </Box>
                      )}
                    </div>
                  </Box>
                </Split>
                {/* <Dialog
              sx={{ height: '100%' }}
              open={dialogToggle1.open}
              onClose={() => setDialogToggle1(false)}
              TransitionComponent={Transition}
              title={dialogToggle1.title}
              content={dialogToggle1.content}
              contentText={dialogToggle1.contentText}
              actions={dialogToggle1.actions}
              useSaveButton={true}
              useCloseButton={true}
              saveButtonName={'삭제'}
              closeButtonName={'닫기'}
              onSave={deleteClick1}
            />
            <Dialog
              sx={{ height: '100%' }}
              open={dialogToggle2.open}
              onClose={() => setDialogToggle2(false)}
              TransitionComponent={Transition}
              title={dialogToggle2.title}
              content={dialogToggle2.content}
              contentText={dialogToggle2.contentText}
              actions={dialogToggle2.actions}
              useSaveButton={true}
              useCloseButton={true}
              saveButtonName={'삭제'}
              closeButtonName={'닫기'}
              onSave={deleteClick2}
            /> */}
              </Box>
            </Box>
          }
        />
      </Grid>
    </Grid>
  );
}

export default ADM_BASIC;
